import './index.scss'
import cvPdf from '../../assets/CV/Master CV.pdf'

const CVPage = () => {
  return (
    <main className="cv-page">
      <div className="site-container">
      <section className="cv-hero">
        <div className="cv-hero__content">
          <p className="eyebrow">Curriculum Vitae</p>
          <h1>View and download my CV</h1>
          <h2>Professional summary, education, skills, and project experience</h2>
          <p>
            This page provides a quick, polished way for recruiters and collaborators to review my CV directly in the browser and download a copy for their records.
          </p>
          <div className="cv-actions">
            <a className="btn btn--primary" href={cvPdf} target="_blank" rel="noreferrer">Open CV</a>
            <a className="btn btn--secondary" href={cvPdf} download>Download CV</a>
          </div>
        </div>
      </section>

      <section className="cv-preview-card">
        <h3>CV Preview</h3>
        <p>
          The full CV is available in the browser using the embedded document viewer below.
        </p>
        <iframe
          title="Christian Turner-Jones CV"
          src={cvPdf}
          className="cv-iframe"
        />
      </section>
      </div>
    </main>
  )
}

export default CVPage
